import z from "zod";
import { unitedStates, UnitedStateCode, countries, CountryIsoCode } from "@goodfill/domain-customer-application-types";
import { isEmailValid } from "../../email/isEmailValid";
import { zRequiredString } from "@goodfill/domain-properties-zod-validators";

export const MUST_AGREE_MESSAGE = "You must agree";
export const zMustAgree = z.boolean().refine((val) => val === true, { message: MUST_AGREE_MESSAGE });

export const SIGNATURE_MESSAGE = "Signature must match your first and last name";

export const zRequiredEmail = z.custom<string>(validateRequiredEmail, { message: "invalid email" });

export const MIN_ZIP_CODE_SIZE = 5;
export const zRequiredZipCode = zRequiredString().min(MIN_ZIP_CODE_SIZE);

export const usStateCodes = Object.keys(unitedStates) as UnitedStateCode[];
// rome-ignore lint/suspicious/noExplicitAny: <explanation>
export const zUsStateIsoCode = z.custom<UnitedStateCode>((value) => usStateCodes.includes(value as any));

export const countryCodes = Object.keys(countries) as CountryIsoCode[];
// rome-ignore lint/suspicious/noExplicitAny: <explanation>
export const zCountryIsoCode = z.custom<CountryIsoCode>((value) => countryCodes.includes(value as any));

// rome-ignore lint/suspicious/noExplicitAny: <explanation>
export function validateRequiredEmail(email: any): boolean {
  return typeof email === "string" && isEmailValid(email.trim());
}

const usSsnRegex = new RegExp(
  "^(?!\\b(\\d)\\1+(\\d)\\1+(\\d)\\1+\\b)(?!123456789|219099999|078051120)(?!666|000)\\d{3}(?!00)\\d{2}(?!0{4})\\d{4}$",
);

export const zRequiredSocialSecurityNumber = zRequiredString().regex(usSsnRegex, {
  message: "Social Security Number is not valid",
});
